import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_AI_CONVERSATION_STATE,
});

export const fetchAiConversationsByLead = (lead) => ({
  type: types.FETCH_AI_CONVERSATIONS_BY_LEAD.REQUEST,
  lead,
});

export const fetchAiConversationsByLeadSuccess = (aiConversations) => ({
  type: types.FETCH_AI_CONVERSATIONS_BY_LEAD.SUCCESS,
  aiConversations,
});

export const fetchAiConversationsByLeadFailure = (error) => ({
  type: types.FETCH_AI_CONVERSATIONS_BY_LEAD.FAILURE,
  error,
});

export const fetchAiConversationMessages = (conversationId) => ({
  type: types.FETCH_AI_CONVERSATION_MESSAGES.REQUEST,
  conversationId,
});

export const fetchAiConversationMessagesSuccess = (messages) => ({
  type: types.FETCH_AI_CONVERSATION_MESSAGES.SUCCESS,
  messages,
});

export const fetchAiConversationMessagesFailure = (error) => ({
  type: types.FETCH_AI_CONVERSATION_MESSAGES.FAILURE,
  error,
});

export const stopAiConversation = (conversation) => ({
  type: types.STOP_AI_CONVERSATION.REQUEST,
  conversation,
});

export const stopAiConversationSuccess = () => ({
  type: types.STOP_AI_CONVERSATION.SUCCESS,
});

export const stopAiConversationFailure = (error) => ({
  type: types.STOP_AI_CONVERSATION.FAILURE,
  error,
});
